import { createRef, useMemo, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
// img
import { useNavigate, useParams } from "react-router-dom";
import { HOME_EDUCATION_CLIENT_DETAIL, SCHOOL_CLIENT_DETAIL, SCHOOL_CLIENT_LIST } from "config/paths";
import { Formik } from "formik";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, errorMessageToast, getAge, getPdfBlob, isValidValue, ReportsNoRecordMessage, successMessageToast, userFullName } from "helpers/common";
import { CLIENT_REPORT_TYPES, dobFormat, GOAL_TRACK_DEFAULT_VALUES_V2, INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS, REPORT_IDS } from "config/constants";
import LoadingButton from "components/shared/LoadingButton";
import moment from "moment";
import ReportError from "components/shared/ReportsV2/ReportError";
import GuardianDetailList from "components/shared/ReportsV2/GuardianDetailsList";
import { useGetDisciplineAreasQuery, useUploadFileMutation } from "store/services/utility";
import { useGetReportClientsAssessmentFeedbackQuery, useSubmitIndividualSessionReportMutation } from "store/services/clients/reports-v2/schoolReports";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useSelector } from "react-redux";
import ViewPdfModal from "components/Modals/ViewPdfModal";
import arro_right_img from "../../../../../../Assets/images/arrow-right.png";
import preview_img from "../../../../../../Assets/images/preview-btn.png";
import ClientDetails from "components/shared/ReportsV2/ClientDetails";
import { ArrowLeftIcon } from "Assets/icons";
import RenderQuestion from "components/shared/ReportsV2/Questions/Index";
import GoalsTracking from "components/shared/ReportsV2/GoalsTracking/Index";
import { formatReportFeedbackV2, isTrialTrackerEmpty, reportInitialValuesV2 } from "helpers/assessment";
import IndividualSessionReportPdfDocV2 from "components/PDF/Clients/ReportsV2/IndividualSessionReportPdfV2";
import down_arrow_img from "../../../../../../Assets/images/down-arro.png";
import { cloneDeep, isEmpty } from "lodash";
import ApprenticeSelect from "components/shared/ReportsV2/ApprenticeSelect";
import getValidationSchema from "./validation";
import PDFDocViewer from "components/PDF/PDFDocViewer";
import ReportSubmitButton from "components/shared/ReportsV2/ReportSubmitButton";
import PdfPublishModal from "components/Modals/PdfPublishModal";
import AutosaveReport from "components/shared/ReportsV2/AutosaveReport";

const defaultRecommendations = [{
  answers: "",
},
{
  answers: "",
}
];

const HomeIndividualSessionReport = () => {
  const navigate = useNavigate();
  const [previewMode, setPreviewMode] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [pdfModal, setPdfModal] = useState(false)
  const [publishPdfModal, setPublishPdfModal] = useState(false)
  const [goalSubmissionError, setGoalSubmissionError] = useState(null);
  const [chartImages, setChartImages] = useState(null);
  const { assessmentId, clientId, reportId } = useParams();
  const clientType = "home_education"

  const [reportHeading, setReportHeading] = useState(CLIENT_REPORT_TYPES[REPORT_IDS.INDIVIDUAL_SESSION_REPORT_V2]?.title);

  const [submitReport, { isLoading: submitReportLoading }] = useSubmitIndividualSessionReportMutation();
  const { data, isLoading, isFetching, isError, refetch } = useGetReportClientsAssessmentFeedbackQuery({ reportId: REPORT_IDS.INDIVIDUAL_SESSION_REPORT_V2, clientId, clientType: "home_education", submittedReportId: reportId });
  const [document, setDocument] = useState(null)
  const [currentTab, setCurrentTab] = useState(1)

  const assessmentAssignedId = data?.assesment?.id;
  const reportQuestions = data?.assesmentData?.reportQuestions;

  const reportGoals = data?.assesmentData?.reportGoals;
  let reportRecommendations = [];
  if (data?.assesmentData?.reportRecommendations?.length > 0) {
    reportRecommendations = data?.assesmentData?.reportRecommendations?.map(item => {
      return {
        id: item?.id,
        answers: item?.answers,
        attachmentData: isValidValue(item?.attachmentData) ? JSON.parse(item?.attachmentData) : [],
      }
    });
  }

  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const caseApprentice = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "apprentice");
  const therapistDetails = { caseDiscipline, caseTherapist, discipline_id: data?.clientPendingCaseload?.clientCaseloadTherapist?.discipline_id }
  const assesmentData = data?.assesmentData

  const { data: disciplineAreas, isFetching: areasLoading } = useGetDisciplineAreasQuery(therapistDetails?.discipline_id, { skip: !therapistDetails?.discipline_id });
  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();

  const chartRefs = useRef([]);
  const formRefs = useMemo(() => {
    if (!reportGoals?.length) return [];
    return reportGoals?.map((goal) => {
      return createRef();
    });
  }, [reportGoals]);

  const disciplineAreaOptions =
    disciplineAreas?.length > 0
      ? disciplineAreas?.map(area => ({
        value: area.id,
        label: area.name
      }))
      : [];

  const therapist = useSelector((state) => state?.auth?.user)

  const initialValues = useMemo(() => {
    if (!data) return {};
    const guardianList = data?.assesment?.AssesmentGuardianAssigned?.map((item) => ({ id: item?.AssessmentReportGuardians?.id, role: item?.role }))
    const [year, month, day] = data?.client_detail?.dob ? data?.client_detail?.dob.split("-") : "";
    const formattedDob = `${day}${month}${year}`;
    const password = `${data?.firstname}${data?.lastname}${formattedDob}`
    let answers = data?.assesmentData?.reportAnswers;
    let values = {
      screening_date: data?.assesment?.screening_date || new Date(),
      apprentice_id: data?.assesment?.studentSignatureId,
      student: data?.assesment?.studentSignatureId ? { label: userFullName(caseApprentice?.caseTherapist), value: data?.assesment?.studentSignatureId } : null,
      signatureBy: data?.assesment?.signatureBy || therapistDetails?.caseTherapist?.id,
      guardianList,
      recommendation: reportRecommendations?.length ? reportRecommendations : cloneDeep(defaultRecommendations),
      // emailFormData: {
      //   pdfPassword: password
      // }
    };

    values = reportInitialValuesV2(values, reportQuestions, answers);

    return values;
  }, [data, caseApprentice, reportRecommendations]);

  const validationSchema = useMemo(() => {
    return getValidationSchema(currentTab, reportQuestions)
  }, [reportQuestions, currentTab]);

  const isValidGoalTracking = () => {
    let isValid = true;

    if (currentTab !== 2) {
      return isValid;
    }

    const emptyTrackerAreas = [];
    (formRefs?.length && reportGoals?.length) && reportGoals?.forEach((goal, index) => {
      if (!formRefs[index]?.current) return;
      let values = formRefs[index].current.values;
      if (values?.hasUnsavedChanges) {
        errorMessageToast("There are unsaved changes in trial tracker, please save them before proceeding", {
          toastId: "goals-error",
        });
        isValid = false;
      }
      if (isTrialTrackerEmpty(values)) {
        emptyTrackerAreas.push(index + 1);
      }
    });

    if (emptyTrackerAreas.length) {
      errorMessageToast(`Please enter trial tracker counts for Area ${emptyTrackerAreas.join(", ")}, or remove the trial tracker`, {
        toastId: "goals-tracker-error",
      });
      isValid = false;
    }

    return isValid;
  }

  const handleSubmitStep = async (values) => {
    setSubmitting(true);

    try {
      let payload = formatReportFeedbackV2(reportHeading, reportQuestions, { ...values });

      let body = {
        goals: [],
        assesment_location: "in-person",
        feedbacks: payload.feedbacks,
        screening_date: values?.screening_date,
        report_heading: reportHeading,
        guardianList: values?.guardianList,
        recommendation: values?.recommendation,
        signatureBy: values?.signatureBy,
      };

      if (currentTab === 2 && !values?.isAutoSave) {
        // save chart images for later use
        const images = await getChartImages();
        if (images) {
          setChartImages(images);
        }
      }

      (formRefs?.length && reportGoals?.length) && reportGoals?.forEach((goal, index) => {
        if (!formRefs[index]?.current) return;

        let values = formRefs[index].current.values;

        body.goals.push({
          goal_id: goal.id,
          goal_notes: values?.goal_notes,
          goal_attachementData: values?.goal_attachementData,
          show_tracker: values?.show_tracker,
          scores: values?.scores || GOAL_TRACK_DEFAULT_VALUES_V2,
        })
      });

      setGoalSubmissionError(null);

      if (therapist?.role_type == "apprentice" || values?.saveForLater) {
        body = {
          ...body,
          studentSignatureId: values?.apprentice_id,
          save_for_later: "yes",
        }
      }
      else {

        const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
          [...data.client_detail.client_guardian_mapping]
            .map((guardian) => {
              const id = guardian?.client_guardian?.id;
              const role = guardian?.client_guardian?.client_role?.title;

              const matchedGuardian = values?.guardianList?.find(
                (item) => item.id === id
              );

              if (matchedGuardian) {
                return {
                  ...guardian,
                  key: matchedGuardian?.role  // or matchedGuardian.role
                };
              }

              return null;
            })
            .filter(Boolean);

        const pdfData = {
          ...body,
          clientId: data?.id,
          lastname: data?.lastname,
          firstname: data?.firstname,
          city_town: data?.client_detail?.city_town,
          dob: dateFormat(data?.client_detail?.dob, dobFormat),
          age: getAge(data?.client_detail?.dob),
          grade: data?.client_detail?.grade,
          schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
          schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
          screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
          selectedGuardians,
          reportHeading,
          therapist,
          apprentice: values?.apprentice_id,
          caseApprentice,
          therapistSignature: therapist?.signature_img,
          emailSignature: therapist?.email_signature,
          reportDate: moment(new Date()).format("MMMM D, YYYY"),
          reportQuestions: data?.assesmentData?.reportQuestions,
          reportAnswers: data?.assesmentData?.reportAnswers,
          assessmentGoals: reportGoals,
          images: chartImages,
          reportRecommendations: values?.recommendation,
        }

        const doc = (
          <IndividualSessionReportPdfDocV2
            data={pdfData}
            clientType="home_education"
          />
        )

        // setDocument(doc)
        const reportName = CLIENT_REPORT_TYPES[assessmentId]?.name || "Individual session report";

        const filename = `${reportName} - ${caseDiscipline?.assign_term} - ${moment(new Date()).format("YYYY-MM-DD")}.pdf`
        let pdfFile = await getPdfBlob(doc, false, filename);

        let uploadedFileName = await uploadFile({ file: pdfFile, acl: "private", fileOriginalFormat: true }).unwrap();

        if (!uploadedFileName) {
          throw new Error("File not uploaded");
        };


        body = {
          ...body,
          pdfData: [{
            attachment_key: uploadedFileName,
            attachment_name: reportName,
          }],
          emailFormData: values?.emailFormData,
          current_step: "submit_and_email",
        }
      }

      const response = await submitReport({ data: body, clientId: assessmentAssignedId, clientType }).unwrap()
      refetch()
      setSubmitting(false);
      if (!values?.isAutoSave) {
        successMessageToast(response.message)
      }
      if (!values?.saveForLater) {
        // navigate(SCHOOL_CLIENT_LIST)
        navigate(HOME_EDUCATION_CLIENT_DETAIL.replace(":id", clientId))
      }
    } catch (error) {
      setSubmitting(false);
      console.log('error', error)
    }
  };

  const handleViewPdf = async (values) => {
    const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
      [...data.client_detail.client_guardian_mapping]
        .map((guardian) => {
          const id = guardian?.client_guardian?.id;
          const role = guardian?.client_guardian?.client_role?.title;

          const matchedGuardian = values?.guardianList?.find(
            (item) => item.id === id
          );

          if (matchedGuardian) {
            return {
              ...guardian,
              key: matchedGuardian?.role  // or matchedGuardian.role
            };
          }

          return null;
        })
        .filter(Boolean);

    const pdfData = {
      clientId: data?.id,
      lastname: data?.lastname,
      firstname: data?.firstname,
      city_town: data?.client_detail?.city_town,
      dob: dateFormat(data?.client_detail?.dob, dobFormat),
      age: getAge(data?.client_detail?.dob),
      grade: data?.client_detail?.grade,
      schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
      schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
      screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
      selectedGuardians,
      reportHeading,
      therapist,
      apprentice: values?.apprentice_id,
      caseApprentice,
      therapistSignature: therapist?.signature_img,
      emailSignature: therapist?.email_signature,
      reportDate: moment(new Date()).format("MMMM D, YYYY"),
      reportQuestions: data?.assesmentData?.reportQuestions,
      reportAnswers: data?.assesmentData?.reportAnswers,
      assessmentGoals: reportGoals,
      images: chartImages,
      reportRecommendations: values?.recommendation,
    }

    const doc = (
      <IndividualSessionReportPdfDocV2
        data={pdfData}
        clientType="home_education"
      />
    )

    setDocument(doc)
    setPdfModal(true)

  };

  const getChartImages = async () => {
    if (!chartRefs.current?.length) {
      return null;
    }
    return await Promise.all(
      chartRefs.current.map(async (ref) => {
        if (ref) {
          return await ref.generateImage();
        }
        return null;
      })
    );
  }

  // const doc = (
  //   <DischargeScreeningPdfDocV2
  //     data={{}}
  //   />
  // )
  return (
    <>
      {/* <PDFDocViewer doc={<IndividualSessionReportPdfDocV2 />} /> */}
      <section className="ReportSec proxima container-discharge-screen py-3 position-relative">
        <Container fluid>
          <div style={{ maxWidth: "80%", margin: "0 auto" }}>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmitStep}
              validationSchema={validationSchema}
              enableReinitialize
            >
              {({ handleSubmit, values, errors, touched, setFieldValue, submitForm, isValid, validateForm }) => (
                <Form onSubmit={handleSubmit}>
                  {isLoading ? (
                    <LoadingIndicator />
                  ) : isError ? (
                    <ErrorComponent />
                  ) : (
                    <>
                      <ViewPdfModal
                        show={pdfModal}
                        clientType={clientType}
                        setShow={setPdfModal}
                        doc={document}
                        handleSubmit={submitForm}
                        guardianList={data?.client_detail?.client_guardian_mapping}
                        publishPdfCheckbox={true}
                      />
                      <PdfPublishModal publishPdfCheckbox={true} show={publishPdfModal} setShow={setPublishPdfModal} clientType={clientType} doc={document} handleSubmit={submitForm} guardianList={data?.client_detail?.client_guardian_mapping} />
                      <AutosaveReport
                        delay={120000}
                        onAutosave={handleSubmitStep}
                        isFetching={isFetching}
                        ignoreFields={["goals"]}
                      >
                        <Row>
                          <Col lg="12" className="my-2">
                            <div className="bg-white session-report" style={{ overflow: "hidden" }}>
                              <>
                                {(isFetching || submitting) && <LoadingOverlay />}

                                <div className="formBody reports-v2 pt-3">
                                  <h5 className="section-title mb-0 border-0" style={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px" }}>{therapist?.therapist_discipline?.name}</h5>
                                  <p style={{ fontSize: "20px", marginTop: "5px", color: "#000" }}>Session Report</p>
                                  <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
                                    <div className="d-flex align-items-start gap_20">
                                      <div style={{ width: "145px" }}>
                                        <label style={{ fontSize: '14px', color: "#000" }} className="discharge-screen-label mb-1">DATE OF REPORT</label>
                                        <AppDatePicker
                                          name="screening_date"
                                          className="w-100 py-2"
                                          disabled={previewMode}
                                        />
                                      </div>
                                      {
                                        [2, 3].includes(currentTab) && (
                                          <div className="" style={{ width: "100%", marginTop: "2px" }}>
                                            <h6 className="date-title w-100" style={{ paddingBottom: "6px" }}>CLIENT INFORMATION</h6>
                                            <div className="d-flex text-dark align-items-center justify-content-between">
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>First Name</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.firstname}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>LAST NAME</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.lastname}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CITY/TOWN</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.client_detail?.city_town}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>DATE OF BIRTH</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{dateFormat(data?.client_detail?.dob, dobFormat)}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>GRADE</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.client_detail?.grade}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>AGE</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{getAge(data?.client_detail?.dob)}</p>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      }
                                    </div>
                                  </div>
                                  <Row className="my-1 proxima-regular" style={{ fontSize: "11px", fontWeight: 500 }}>
                                    <Col lg="4" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 1 ? "#3DA0AA" : "#315D99", borderRadius: "3px", color: "white", textAlign: 'center' }}>CONFIRM CLIENT INFO</div>
                                      <div className={`${currentTab == 1 ? "arrow-right-tab-active" : "arrow-right-tab-previous"} position-relative`}></div>
                                      {/* <div className="arrow-right-tab-white position-relative"></div> */}
                                    </Col>
                                    <Col lg="4" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 2 ? "#3DA0AA" : currentTab == 3 ? "#315D99" : "#D9E8FE", borderRadius: "3px", color: (currentTab == 3 || currentTab == 2) ? "white" : "#315D99", textAlign: 'center' }}>ADD SESSION INFORMATION</div>
                                      <div className={`${currentTab == 2 ? "arrow-right-tab-active" : currentTab == 3 ? "arrow-right-tab-previous" : "arrow-right-tab"} position-relative`}></div>
                                      <div className="arrow-right-tab-white position-relative"></div>
                                    </Col>
                                    <Col lg="4" className="p-0">
                                      <div style={{ padding: "9.8px", background: currentTab == 3 ? "#3DA0AA" : "#D9E8FE", borderRadius: "3px", textAlign: 'center', color: currentTab == 3 ? "white" : '#315D99' }}>ADD RECOMMENDATIONS</div>
                                      {/* <div className={`${currentTab == 3 ? "arrow-right-tab-active" : "arrow-right-tab"} position-relative`}></div> */}
                                      <div className="arrow-right-tab-white position-relative"></div>
                                    </Col>
                                  </Row>
                                  {currentTab === 1 ? (
                                    <div
                                      className="mt-4 client-view"
                                    >
                                      <ClientDetails
                                        data={data}
                                        heading="1. CLIENT INFORMATION"
                                      />
                                      {data?.client_detail?.client_guardian_mapping?.[0]?.client_guardian ?
                                        [...data.client_detail.client_guardian_mapping] // clone the array
                                          .map((guardian, index) => {
                                            const slug = guardian?.client_guardian?.client_role?.slug;
                                            if (slug !== "parent") {
                                              return null;
                                            }
                                            if ([0, 1].includes(index)) {
                                              return (
                                                <GuardianDetailList
                                                  previewMode={previewMode}
                                                  key={index}
                                                  index={index}
                                                  guardian={guardian}
                                                  slug={slug}
                                                  values={values}
                                                />
                                              );
                                            }
                                            else {
                                              return
                                            }
                                          }) : <ReportsNoRecordMessage msg="No parent is currently assigned to this client." />}
                                    </div>
                                  ) : currentTab === 2 ? (
                                    <div
                                      className="mt-1 session-info"
                                    >
                                      {reportQuestions?.length > 0 &&
                                        reportQuestions?.map((question, index) => {
                                          if (question.id === INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.session_updates || question.id === INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.location) return (
                                            <div className="py-4 input-label">
                                              <RenderQuestion
                                                key={index}
                                                question={question}
                                                fieldName={question.id}
                                                questionIndex={index}
                                                speechToText
                                              />
                                            </div>
                                          );
                                        }
                                        )}
                                      <div className="goals-tracking">
                                        <GoalsTracking
                                          speechToText
                                          onSubmit={() => handleSubmitStep({
                                            ...values,
                                            saveForLater: true,
                                            isAutoSave: true,
                                          })}
                                          isFetching={isFetching}
                                          // onNavigateBack
                                          clientType={clientType}
                                          chartRefs={chartRefs}
                                          formRefs={formRefs}
                                          error={goalSubmissionError}
                                          data={data}
                                          refetch={refetch}
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="recommendations">
                                      {reportQuestions?.length > 0 &&
                                        reportQuestions?.map((question, index) => {
                                          if (question.id === INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.clinical_impressions) return (
                                            <div className="py-4 input-label">
                                              <RenderQuestion
                                                key={index}
                                                question={question}
                                                fieldName={question.id}
                                                questionIndex={1}
                                                speechToText
                                              />
                                            </div>
                                          );
                                        }
                                        )}
                                      {reportQuestions?.length > 0 &&
                                        reportQuestions?.map((question, index) => {
                                          if (question.id !== INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.recommendation) return;
                                          return (
                                            <div className="py-4">
                                              <RenderQuestion
                                                key={index}
                                                question={question}
                                                fieldName={question.id}
                                                questionIndex={2}
                                                clientType={"school"}
                                                assessmentId={assessmentId}
                                                speechToText
                                              />
                                            </div>
                                          );
                                        }
                                        )}
                                      <div className="mb-2">
                                        <h6 className="section-title text-uppercase">
                                          2. signature
                                        </h6>
                                        <ApprenticeSelect
                                          name={"student"}
                                          caseApprentice={caseApprentice}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </>
                            </div>
                          </Col>

                          <Col lg="12" className="my-2">
                            <ReportError />
                            <div className='d-flex gap-3 align-items-center justify-content-between'>
                              <div>
                                {currentTab > 1 && (
                                  <button
                                    onClick={() => setCurrentTab(currentTab - 1)}
                                    type="button"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    disabled={isFetching || submitting}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    <ArrowLeftIcon />
                                    {currentTab === 3 ? "Back: Add Session Information" : "Back"}
                                  </button>
                                )}
                              </div>
                              <div className="d-flex gap-3 align-items-center justify-content-between">
                                <ReportSubmitButton
                                  onClick={() => setFieldValue('saveForLater', true)}
                                  type="submit"
                                  className="d-flex gap-2 align-items-center justify-content-center save-discharge-screen"
                                  disabled={previewMode || isFetching || submitting}
                                // isLoading={submitReportLoading || submitting}
                                >
                                  Save
                                  {/* {<img width={13} height={6} src={down_arrow_img} alt="down_arrow_img" />} */}
                                  <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.939684 1.3674L6.16086 6.18695C6.35239 6.36374 6.64761 6.36375 6.83914 6.18695L12.0603 1.3674C12.3948 1.05868 12.1763 0.500001 11.7212 0.500001L1.27883 0.5C0.82367 0.5 0.605235 1.05868 0.939684 1.3674Z" fill="white" />
                                  </svg>

                                </ReportSubmitButton>
                                {currentTab === 3 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="d-flex align-items-center gap-2 justify-content-center preview-discharge-screen"
                                      // isLoading={submittingStep}
                                      disabled={isFetching || submitting}
                                      onClick={() => handleViewPdf(values)}
                                    >
                                      {/* <img width={16} height={14} src={preview_img} alt="preview_img" /> */}
                                      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.777778C0 0.571498 0.0842854 0.373667 0.234315 0.227806C0.384344 0.0819442 0.587827 0 0.8 0H15.2C15.4122 0 15.6157 0.0819442 15.7657 0.227806C15.9157 0.373667 16 0.571498 16 0.777778V13.2222C16 13.4285 15.9157 13.6263 15.7657 13.7722C15.6157 13.9181 15.4122 14 15.2 14H0.8C0.587827 14 0.384344 13.9181 0.234315 13.7722C0.0842854 13.6263 0 13.4285 0 13.2222V0.777778ZM1.6 1.55556V12.4444H14.4V1.55556H1.6ZM3.2 3.11111H4.8V4.66667H3.2V3.11111ZM4.8 6.22222H3.2V7.77778H4.8V6.22222ZM3.2 9.33333H4.8V10.8889H3.2V9.33333ZM12.8 3.11111H6.4V4.66667H12.8V3.11111ZM6.4 9.33333H12.8V10.8889H6.4V9.33333ZM12.8 6.22222H6.4V7.77778H12.8V6.22222Z" fill="white" />
                                      </svg>
                                      Preview Report
                                    </button>
                                    {
                                      therapist?.role_type == "veteran" &&
                                      <ReportSubmitButton
                                        // onClick={() => setFieldValue('saveForLater', false)}
                                        onClick={() => { setFieldValue('saveForLater', false); setPublishPdfModal(true) }}
                                        type="button"
                                        className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        disabled={isFetching || submitting}
                                      // isLoading={submitReportLoading || submitting}
                                      >
                                        SUBMIT
                                        {/* <img width={14} height={8} src={arro_right_img} alt="arro_right_img" /> */}
                                      </ReportSubmitButton>
                                    }
                                  </>
                                ) : (
                                  <button
                                    onClick={async () => {
                                      const errors = await validateForm();
                                      if (isEmpty(errors) && isValidGoalTracking()) {
                                        setFieldValue('saveForLater', true);
                                        await submitForm();
                                        setCurrentTab(currentTab + 1);
                                      }
                                    }}
                                    type="button"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    disabled={isFetching || submitting || (currentTab === 2 && !reportGoals?.length)}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    Next
                                    {/* <img width={14} height={8} src={arro_right_img} alt="arro_right_img" /> */}
                                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.68197 3.24568L8.85675 0.5H10.2193L14 4.29259V4.70741L10.2193 8.5H8.85675L9.68197 5.75432H0V3.24568H9.68197Z" fill="white" />
                                    </svg>

                                  </button>
                                )}
                              </div>
                            </div>
                          </Col>

                        </Row>
                      </AutosaveReport>
                    </>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </Container>
      </section >
    </>
  );
};

export default HomeIndividualSessionReport;